import { getEnumValues } from "sprint-common-web";

export enum OrderColumn {
    PoNumber = 1,
    Content = 2,
    Airline = 3,
    System = 4,
    StartDate = 5,
    DeliveryDate = 6,
    Info = 7,
    Video = 8,
    Soundtracks = 9,
    Subtitles = 10,
    Status = 11,
    CreatedDate = 12,
    Runtime = 13,
    TargetFilenames = 14,
    Progress = 15,
    Actions = 16,
    DueDate = 17,
    Resolution = 18,
    Source = 19
}

export interface ColumnConfig {
    order: number;
    visible: boolean;
}

export interface OrderListingConfig {
    pageSize: number;
    columns: ConfiguredOrderColumns;
}

type ConfiguredOrderColumns = Record<OrderColumn, ColumnConfig>;

export const getDefaultOrderListingConfig = (): OrderListingConfig => ({
    pageSize: 50,
    columns: {
        [OrderColumn.PoNumber]: { order: 1, visible: true },
        [OrderColumn.Content]: { order: 2, visible: true },
        [OrderColumn.Airline]: { order: 3, visible: true },
        [OrderColumn.System]: { order: 4, visible: true },
        [OrderColumn.StartDate]: { order: 5, visible: true },
        [OrderColumn.DueDate]: { order: 6, visible: true },
        [OrderColumn.DeliveryDate]: { order: 7, visible: true },
        [OrderColumn.Progress]: { order: 8, visible: true },
        [OrderColumn.Info]: { order: 9, visible: true },
        [OrderColumn.Source]: { order: 10, visible: true },
        [OrderColumn.TargetFilenames]: { order: 11, visible: true },
        [OrderColumn.Runtime]: { order: 12, visible: true },
        [OrderColumn.Resolution]: { order: 13, visible: true },
        [OrderColumn.Video]: { order: 14, visible: true },
        [OrderColumn.Soundtracks]: { order: 15, visible: true },
        [OrderColumn.Subtitles]: { order: 16, visible: true },
        [OrderColumn.Status]: { order: 17, visible: true },
        [OrderColumn.CreatedDate]: { order: 18, visible: true },
        [OrderColumn.Actions]: { order: 19, visible: true }
    }
});

export const getSortedOrderColumns = (columnConfig: ConfiguredOrderColumns): [string, ColumnConfig][] => {
    /* ensures that columns not present in LocalStorage config (i.e. newly added) are present in the listing config modal */
    const allColumns: ConfiguredOrderColumns = { ...getInvisibleDefaultColumns(), ...columnConfig };
    const supportedColumns = new Set(getEnumValues(OrderColumn));

    return (
        Object.entries(allColumns)
            /* ensures no unrecognized values are displayed in the config dialog */
            .filter(([columnKey]) => supportedColumns.has(Number(columnKey)))
            .sort(([, valueA], [, valueB]) => {
                const columnA = valueA.order;
                const columnB = valueB.order;
                return columnA - columnB;
            })
    );
};

const getInvisibleDefaultColumns = () => {
    const defaultColumns = getDefaultOrderListingConfig().columns;
    const entries = Object.entries(defaultColumns).map(([colName, colCfg]) => [colName, { ...colCfg, visible: false }]);

    return Object.fromEntries(entries);
};
